import { commonCrossAnalysis, commonGstURL1, commonV3URL } from 'src/constantsMessage';
import axios from 'src/utils/axiosHelper';
import { SET_ALERT } from 'src/actions/alertAction';
import helperAxios from 'src/utils/helperAxios';

export const GET_ALLAGGREGATE = '@analysis/get-allaggregate';
export const GET_ALLAGGREGATE_ERROR = '@analysis/get-allaggregate-error';
export const GET_ALLAGGREGATE_EMPTY = '@analysis/get-allaggregate-empty';
export const LOADER = '@allAggregate/loader';

export function getAllAggregate(refId) {
  const url = `${commonCrossAnalysis}/overview?reportReferenceId=${refId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_ALLAGGREGATE,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_ALLAGGREGATE_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export const allAggregateEmpty = () => {
  return dispatch => {
    dispatch({ type: GET_ALLAGGREGATE_EMPTY });
  };
};
